/* =========================================================================
 * PRECHECKOUT (MIGRADO A @SHOPIFY/STOREFRONT-API-CLIENT)
 * ========================================================================= */
console.log("Carrito script cargado con nuevo Storefront API Client...");

/* -------------------------------------------------------------------------
 * 1. CONSTANTES Y ALMACENAMIENTO LOCAL
 * ------------------------------------------------------------------------- */
const CUSTOMER_KEY = "customerData";

function setCustomerData(field, value) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    data[field] = value;
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}

function getCustomerData(field) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    return data[field] || null;
}

function getAllCustomerData() {
    return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}

function clearCustomerData() {
    localStorage.removeItem(CUSTOMER_KEY);
}

function setLocalStorageCustomerData() {
    setCustomerData("firstName", $("#enova-billing-name").val());
    setCustomerData("lastName", $("#enova-billing-lastName").val());
    setCustomerData("email", $("#enova-billing-email").val());
    setCustomerData("phone", $("#enova-billing-telefono").val());
    setCustomerData("documentType", $("#enova-billing-documento-type").val());
    setCustomerData("documentNumber", $("#enova-billing-documento-number").val());

    setCustomerData("shippingMethodType", $('input[name="enova-despacho-tipo"]:checked').val());
    setCustomerData("shippingMethod", $('input[name="enova-despacho"]:checked').val());
    setCustomerData("region", $("#enova-carrito-block-despacho-shipping__departamento").val());
    setCustomerData("city", $("#enova-carrito-block-despacho-shipping__provincia").val());
    setCustomerData("locality", $("#enova-carrito-block-despacho-shipping__distrito").val());

    setCustomerData("address", $("#enova-despacho-direccion").val());
    setCustomerData("reference", $("#enova-despacho-referencia").val());

    setCustomerData("billingType", $('input[name="enova-billing-doc"]:checked').val());
    setCustomerData("ruc", $("#enova-billing-doc-ruc").val() || "");
    setCustomerData("companyName", $("#enova-billing-doc-razonsocial").val() || "");
    setCustomerData("loaded", false);
}

function setInitCustomerData() {
    const customerData = getAllCustomerData();
    if (Object.keys(customerData).length === 0) {
        if (window.ShopifyCustomer && window.ShopifyCustomer.logged_in) {
            $("#enova-billing-name").val(window.ShopifyCustomer.firstName);
            $("#enova-billing-lastName").val(window.ShopifyCustomer.lastName);
            $("#enova-billing-email").val(window.ShopifyCustomer.email);
        }
    } else {
        $("#enova-billing-name").val(getCustomerData("firstName"));
        $("#enova-billing-lastName").val(getCustomerData("lastName"));
        $("#enova-billing-email").val(getCustomerData("email"));
        $("#enova-billing-telefono").val(getCustomerData("phone"));
        $("#enova-billing-documento-type").val(getCustomerData("documentType"));
        $("#enova-billing-documento-number").val(getCustomerData("documentNumber"));
        
        let savedShippingMethod = getCustomerData("shippingMethod");
        if (savedShippingMethod) {
            let $shippingRadio = $(`input[name="enova-despacho"][value="${savedShippingMethod}"]`);
            if ($shippingRadio.length) {
                $shippingRadio.prop('checked', true);
                $shippingRadio.closest('.enova-despacho-selector-item').click();
            }
        }
        
        if (savedShippingMethod == 'delivery') {
            $("#enova-despacho-shipping").css("display", "block");
            $("#enova-despacho-direccion").val(getCustomerData("address"));
            $("#enova-despacho-referencia").val(getCustomerData("reference"));
        } else {
            $("#enova-despacho-shipping").css("display", "none");
            $("#enova-despacho-recojo-tienda").css("display", "block");
        }
    
        let savedBillingType = getCustomerData("billingType");
        if (savedBillingType) {
            let $billingRadio = $(`input[name="enova-billing-doc"][value="${savedBillingType}"]`);
            if ($billingRadio.length) {
                $billingRadio.prop('checked', true);
                $billingRadio.closest('.enova-billing-item').click();
            }
        }
        
        if (savedBillingType == "factura") {
            $("#enova-billing-doc").css("display", "block");
            $("#enova-billing-doc-ruc").val(getCustomerData("ruc"));
            $("#enova-billing-doc-razonsocial").val(getCustomerData("companyName"));
        }
    }
}

/* -------------------------------------------------------------------------
 * 2. STOREFRONT API CLIENT & REDIRECCIÓN
 * ------------------------------------------------------------------------- */
// Inicialización del nuevo Storefront API Client Oficial de Shopify
const client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: 'perfumarte.pe',
    apiVersion: '2026-07', 
    publicAccessToken: 'd4cb62cb0e6f65cfedb95f220ff9a275',
    customFetchApi: window.fetch 
});

async function populate(scope = "departaments", options) {
    try {
        let countrySelected = options.country;
        let departamentoSelected = options.departament;
        let provinceSelected = options.district;
        let urlBuilder = null;

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`;
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`;
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`;
        }

        let departamentos = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
            "method": "GET",
            "headers": { 'Content-Type': 'application/json' }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active;
                } else {
                    return item;
                }
            });
            return filteredResponse;
        })
        .then((response) => {
            console.log("response", response);
            return response;
        })
        .catch(error => console.error('Error:', error));

        console.log("UBIGEOS - ", scope, departamentos);
        return departamentos;

    } catch(err) {
         console.log("err", err);
         return err;
    }
}
 
async function getPickUpShopList(filter_zona = null) {
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>");

    let shopsList = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation?scope=shop-addresses`, {
        "method": "GET",
        "headers": { 'Content-Type': 'application/json' }
    })
    .then((res) => res.json())
    .then((response) => response)
    .catch(error => console.error('Error:', error));

    console.log("lista de tiendas", shopsList);

    let list_stores_filtered = [];
    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona;
        });
        shopsList = list_stores_filtered;
    }

    let templateBlockStoreList = "";
    for(let store of shopsList) {
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.code}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.code}" data-departamento="${store.department}" data-provincia="${store.province}" data-distrito="${store.distrit}" data-ubigeo="${store.ubigeo}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name}</h3>
                    <p class="enova-tienda-direccion">${store.address}</p>
                    <p class="enova-tienda-complement">${store.complement}</p>
                </div>
            </label>
        `;
        templateBlockStoreList += templateItemElement;
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList);

    setTimeout(() => {
        setStoresEventClick();
    }, 300);

    return shopsList;
}

async function getTotalCart(format = null) {
    let totalCart = 0
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    const dataCart = await responseCart.json();
    return dataCart.total_price / 100
}

async function getResponseCartItems(format = null) {
    let carritoItems = [];
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const dataCart = await responseCart.json();

    const utf8_to_b64 = (str) => window.btoa(unescape(encodeURIComponent(str)));

    for (let item of dataCart.items) {
        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`;
        
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo");
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val();
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val();

        let existingAttributes = [];
        if (item.properties) {
            existingAttributes = Object.entries(item.properties).map(([key, value]) => ({
                key: key,
                value: String(value)
            }));
        }

        let newAttributes = [
            { key: "_tipo de despacho", value: String(getDespacho) },
            { key: "_shipping method", value: String(getShippingMethod) },
            { key: "_ubigeo", value: String(getUbigeoSelected) },
            { key: "_peso", value: String(item.grams) },
            { key: "_sku", value: String(item.sku) },
            { key: "_final_price", value: String(item.final_price) }
        ];

        let combinedAttributes = [...existingAttributes, ...newAttributes];

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: combinedAttributes
        };

        if (format) {
            lineItemsToAdd['requires_shipping'] = true; 
        }

        carritoItems.push(lineItemsToAdd);
    }
    return carritoItems;
}

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        let carritoItemsList = await getResponseCartItems();
        
        // Mapeo estructurado para los atributos personalizados del carrito
        let cartAttributesList = [];
        for (let cartKey in cartAttributes.attributes) {
            cartAttributesList.push({
                key: cartKey,
                value: String(cartAttributes.attributes[cartKey])
            });
        }

        function getProvinceCorrelatives(province) {
            switch(province) {
                case "Lima":
                case "LIMA":
                    return "PE-LMA";
                default:
                    return province;
            }
        }

        // NUEVA MUTACIÓN: Usamos cartCreate (Válida en la API 2026)
        const cartCreateMutation = `
            mutation cartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                    cart {
                        id
                        checkoutUrl
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
        `;

        const variables = {
            input: {
                attributes: cartAttributesList,
                lines: carritoItemsList.map(item => ({
                    merchandiseId: item.variantId,
                    quantity: parseInt(item.quantity),
                    attributes: item.attributes
                })),
                buyerIdentity: {
                    email: cartAttributes.attributes.email,
                    phone: cartAttributes.attributes['telefono'].startsWith("+") ? cartAttributes.attributes['telefono'] : `+51${cartAttributes.attributes['telefono']}`,
                    deliveryAddressPreferences: [
                        {
                            deliveryAddress: {
                                firstName: cartAttributes.attributes['nombre'],
                                lastName: cartAttributes.attributes['apellido'],
                                phone: cartAttributes.attributes['telefono'].startsWith("+") ? cartAttributes.attributes['telefono'] : `+51${cartAttributes.attributes['telefono']}`,
                                country: "PE",
                                province: getProvinceCorrelatives(cartAttributes.attributes['departamento']),
                                city: String(cartAttributes.attributes['distrito']).trim(),
                                address1: String(cartAttributes.attributes['direccion']).trim(),
                                address2: String(cartAttributes.attributes['referencia']).trim(),
                                zip: String(cartAttributes.attributes['ubigeo'])
                            }
                        }
                    ]
                }
            }
        };

        console.log("Ejecutando mutación cartCreate con variables:", variables);

        // Envío de la consulta mediante el nuevo SDK .request()
        const response = await client.request(cartCreateMutation, { variables });

        // Validación de errores adaptada al nuevo objeto Cart
        if (response.errors || response.graphQLErrors || (response.data && response.data.cartCreate.userErrors && response.data.cartCreate.userErrors.length > 0)) {
            let errorLog = response.graphQLErrors || response.errors || response.data?.cartCreate?.userErrors || [];
            console.error("--- DETALLE DE ERRORES DE SHOPIFY GRAPHQL ---");
            console.error(errorLog);
            console.error("---------------------------------------------");
            throw new Error(errorLog[0]?.message || "Error al procesar el Carrito en Shopify");
        }

        // Extraemos los datos del nuevo objeto de retorno
        const cartData = response.data.cartCreate.cart;
        console.log("Carrito creado satisfactoriamente en Shopify:", cartData);
        
        // Retornamos una simulación del objeto antiguo para no romper tu lógica de redirección del JS principal
        return { 
            checkout: { 
                id: cartData.id,
                webUrl: cartData.checkoutUrl // URL nativa de pasarela que incluye todos los datos pre-llenados
            } 
        };
        
    } catch(err) {
        console.log("Error crítico durante la creación del flujo de checkout:", err);
        checkoutButtonLoader(false);
        document.querySelector("#enova-message-carrito").textContent = "No se pudo iniciar el pago, por favor intente nuevamente en unos minutos.";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return err;
    }
}

/* -------------------------------------------------------------------------
 * 3. LÓGICA Y REGLAS DE VALIDACIÓN
 * ------------------------------------------------------------------------- */
function validateDeliveryForm(objectForm) {
    let validated = true;
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key]);
        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false;
        }
    }
    return validated;
}

function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping;
        if(isShipping) {
            isCarritoReadyForShipping = true;
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true;
    }

    return isCarritoReadyForShipping;
}

function setLogistictProgrammedDateRules() {
    const inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
    if (!inputFecha) return;

    const hoy = new Date();
    const horaActual = hoy.getHours();
    let horarioCorte = 21; // 9PM
    
    if (hoy.toLocaleDateString() == "31/12/2025") { horarioCorte = 12; }
    if (hoy.toLocaleDateString() == "24/12/2025") { horarioCorte = 12; }
    
    const feriados = [
        "30-08-2025", "31-08-2025", "01-11-2025", "02-11-2025", "08-12-2025",
        "09-12-2025", "10-12-2025", "24-12-2025", "25-12-2025", "28-12-2025",
        "01-01-2026", "10-01-2026",
    ];

    function esFeriado(fecha) {
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const anio = fecha.getFullYear();
        const fechaStr = `${dia}-${mes}-${anio}`;
        if (dia === '05' && mes === '08' && anio === '2025') return false;
        return feriados.includes(fechaStr);
    }

    inputFecha.innerHTML = '';
    let ubigeo = '150101';
    try {
        const ubigeoElement = $('#enova-carrito-block-despacho-shipping__distrito option:selected');
        if (ubigeoElement.length && ubigeoElement.data('ubigeo')) {
            ubigeo = ubigeoElement.data('ubigeo').toString();
        }
    } catch (e) {}

    let diasHabilesDesdeHoy = 1;
    const fechaInicio = new Date(hoy);
    const diaHoy = hoy.getDay(); 

    const diasAntesDeCorte = { 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 2, 0: 2 };
    const diasDespuesDeCorte = { 1: 2, 2: 2, 3: 3, 4: 2, 5: 4, 6: 3, 0: 2 };

    const mapa = horaActual >= horarioCorte ? diasDespuesDeCorte : diasAntesDeCorte;
    fechaInicio.setDate(fechaInicio.getDate() + mapa[diaHoy]);

    const diasValidos = [];
    const temp = new Date(fechaInicio);
    const nombres = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    while (diasValidos.length < 7) {
        const d = temp.getDay();
        if (d !== 0 && !esFeriado(temp)) {
            diasValidos.push({
                fecha: formatDateToDDMMYYYY(temp),
                dia: nombres[d]
            });
        }
        temp.setDate(temp.getDate() + 1);
    }

    diasValidos.forEach(({ fecha, dia }) => {
        const opt = document.createElement('option');
        opt.value = fecha;
        opt.textContent = `${dia}, ${fecha}`;
        inputFecha.appendChild(opt);
    });

    function formatDateToDDMMYYYY(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${d}-${m}-${y}`;
    }
}

/* -------------------------------------------------------------------------
 * 4. UI / DOM UPDATES
 * ------------------------------------------------------------------------- */
function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled");
    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled");
    }
}

function checkoutButtonLoader(status) {
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'none');
        jQuery("#enova_cart-data-submit").css("opacity", '.5');
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'initial');
        jQuery("#enova_cart-data-submit").css("opacity", '1');
    }
}

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione</option>`;
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function setSelectorOptions(scope, optionList, addressBilling = null) {
    let templateList = '<option>Seleccione...</option>';
    for(let optionUbigeo of optionList) {
        let itemOptionTemplate = `
            <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
        `;
        templateList += itemOptionTemplate;
    }
    
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = '';
    let ubigeo = '';
    try {
        ubigeo = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo").toString();
    } catch (e) {}
    const horaActual = new Date().getHours();

    for (let method of methodsList) {
        let description = method.description || '';
        let methodName = method.name || '';

        if (method.display_rules && method.display_rules.rules && method.display_rules.rules.length > 0) {
            const matchedRule = method.display_rules.rules.find(rule => {
                if (rule.ubigeo_prefix === '*') return true;
                return ubigeo.startsWith(rule.ubigeo_prefix);
            });

            if (matchedRule) {
                if (matchedRule.cutoff_hour && matchedRule.before_cutoff && matchedRule.after_cutoff) {
                    description = horaActual < matchedRule.cutoff_hour
                        ? matchedRule.before_cutoff
                        : matchedRule.after_cutoff;
                } else {
                    description = matchedRule.default
                }

                if (matchedRule.override_name) {
                    methodName = matchedRule.override_name;
                }
            }
        }

        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-${method.code}" value="${method.code}">
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-tipo__delivery-label enova-shipping-tipo__delivery--method1">
                    <div class="enova-shipping-method-tag-name-title">
                        <span class="enova-shipping-method-title">${methodName} </span>
                        <span class="enova-shipping-method-cost">
                            ${method.is_free_shipping ? 'Gratis' : `S/ ${method.price}`}
                        </span>
                    </div>
                    <div class="enova-shipping-method-tag-description">
                        <p>${description}</p>
                    </div>
                </label>
            </div>
        `;
        templateList += templateItem;
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList);
    calculateShippingMethodToShowOption();
}

function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
            </label>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `;

    if(document.querySelector(".cart__recap")) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart;
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart);
    }

    const submitBtn = document.querySelector("#enova_cart-data-submit");
    if(submitBtn) {
        submitBtn.addEventListener("click", handleCheckoutSubmit);
    }
}

/* -------------------------------------------------------------------------
 * 5. EVENTOS DE FORMULARIOS
 * ------------------------------------------------------------------------- */
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho]:checked")) {
                if( document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda' ) {
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("active");
                    document.querySelector("#enova-despacho-shipping").classList.remove("active");
    
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled");
                    document.querySelector("#enova-despacho-shipping").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "none");
                    $("#enova-despacho-recojo-tienda").css("display", "block");

                    getPickUpShopList();

                    if( document.querySelector("#enova-despacho-delivery-select-fecha") ) {
                        document.querySelector("#enova-despacho-delivery-select-fecha").value = null;
                    }
                    if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                        document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true;
                    }

                } else if ( document.querySelector("input[name=enova-despacho]:checked").value === 'delivery' ) {
                    document.querySelector("#enova-despacho-shipping").classList.add("active");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active");
    
                    document.querySelector("#enova-despacho-shipping").classList.remove("disabled");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "block");
                    $("#enova-despacho-recojo-tienda").css("display", "none");
                    
                    if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                        document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active");
                    }
                    if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                        document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                    }
                }
                document.querySelector("input[name=enova-despacho]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-billing-doc]:checked")) {
                if( document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' ) {
                    document.querySelector("#enova-billing-doc").classList.add("active");
                    document.querySelector("#enova-billing-doc").classList.remove("disabled");

                    if (document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda') {
                        jQuery("#formulario--billing-address_checkbox").prop("checked", false);
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none");
                    }
        
                } else if ( document.querySelector("input[name=enova-billing-doc]:checked").value === 'boleta' ) {
                    document.querySelector("#enova-billing-doc").classList.remove("active");
                    document.querySelector("#enova-billing-doc").classList.add("disabled");

                    jQuery("#formulario--billing-address_checkbox").prop("checked", true);
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block");
                }
                document.querySelector("input[name=enova-billing-doc]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active");
                }
                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                }
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        let filter_store_selected = ev.target.value;
        getPickUpShopList(filter_store_selected);
    });
}

function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
             $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");
             despachoMethodShippingLoading('loading');

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {
                getTotalCart(true)
                    .then((totalCart) => {

                        despachoMethodShippingLoading('loading');
                        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo"); 
                        let totalWeight = 0
                        
                        let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&total_cart=${totalCart}`;
                        console.log("CARRITO FINAL urlBuilder", urlBuilder);

                        if(SelectedDepartamentoUBIGEO) {
                            fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
                                method: 'GET',
                                headers:{ 'Content-Type': 'application/json' }
                            })
                            .then(res => res.json())
                            .then(response => {
                                console.log('Success:', response);
                                SetRenderShippingMethodsListOption(response);

                                if (getCustomerData("shippingMethodType")) {
                                    let shippingMethodType = getCustomerData("shippingMethodType");
                                    $(`input[name="enova-despacho-tipo"][value="${shippingMethodType}"]`).prop('checked', true).trigger('change');
                                    //if (shippingMethodType == "programmed" && shippingMethodType == $('input[name="enova-despacho-tipo"]:checked').val()) {
                                    //    $(".enova-carrito-block-despacho-shipping__fecha").css("display", "flex");
                                    //}
                                }
                                despachoMethodShippingLoading(null);
                            })
                            .catch(error => {
                                console.error('Error:', error);
                                despachoMethodShippingLoading(null);
                            });
                        } else {
                            alert("Debe seleccionar un Distrito Valido");
                        }

                    })
                    .catch((err) => {
                        console.log("err", err);
                        despachoMethodShippingLoading(null);
                    });
    
            } else {
                despachoMethodShippingLoading(null);
            }
        });
    }
}

function calculateShippingMethodToShowOption() {
    for(let methodOption of document.querySelectorAll("input[name=enova-despacho-tipo]")) {
        methodOption.addEventListener("change", (ev) => {
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");

                if( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-normal") {
                    // none
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "programmed" ) {
                    console.log("label programado");
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-express" ) {
                    // none
                } else {
                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                }
            }
        });
    }
}

function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("");
        $("p.text-has-error.text-typedoc").remove();
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
    });

    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        let input_doc_type_selected = jQuery("#enova-billing-documento-type").val();
        let currentLength = ev.currentTarget.value.length;
        let regex;

        if(input_doc_type_selected === "1") {
            regex = /^[0-9]$/; 
            if (currentLength >= 8) ev.preventDefault(); 
        } else if(input_doc_type_selected === "2") {
            regex = /^[a-zA-Z0-9]$/; 
            if (currentLength >= 12) ev.preventDefault(); 
        } else if(input_doc_type_selected === "3") {
            regex = /^[0-9]$/; 
            if (currentLength >= 11) ev.preventDefault(); 
        } else {
            return; 
        }

        if (!regex.test(ev.key)) {
            ev.preventDefault(); 
        }
    });

    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    $("[for='enova-billing-telefono']").text("Celular");
}

function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1");
    if (buttonCartCheckoutStep) {
        buttonCartCheckoutStep.addEventListener("click", (ev) => {
            let blockCartStep = document.querySelector(".enova-block-carrito-main");
            let blockCart = document.querySelector("#MinimogCart");
            document.querySelector("input[name=enova-despacho]:first-child").click();
        });
    }
}

function initSetFormDataUbigeosAvailable() {
    setResetSelectorOptions('departaments');
    setResetSelectorOptions('provinces');
    setResetSelectorOptions('distrits');
    setResetSelectorOptions('departaments', true);
    setResetSelectorOptions('provinces', true);
    setResetSelectorOptions('distrits', true);

    populate("departaments", { country: "1", departament: null, district: null })
    .then((result) => {
        let departmentsList = result ;
        setSelectorOptions("departaments", departmentsList);
        setSelectorOptions("departaments", departmentsList, true);
        
        let region = getCustomerData("region");
        if (region) {
            $("#enova-carrito-block-despacho-shipping__departamento").val(region).change();
        }
    })
    .catch((err) => console.log("err ubigeo selector departaments", err));

    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {
        setResetSelectorOptions('provinces');
        setResetSelectorOptions('distrits');

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => {
            let provincesList = result ;
            setSelectorOptions("provinces", provincesList);

            let city = getCustomerData("city");
            if (city && $("#enova-carrito-block-despacho-shipping__departamento").val() == getCustomerData("region")) {
                $("#enova-carrito-block-despacho-shipping__provincia").val(city).change();
            }
        })
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits');
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => {
            let districtList = result ;
            setSelectorOptions("distrits", districtList);

            let locality = getCustomerData("locality");
            if (locality && $("#enova-carrito-block-despacho-shipping__provincia").val() == getCustomerData("city")) {
                $("#enova-carrito-block-despacho-shipping__distrito").val(locality);
                const distrito = document.querySelector("#enova-carrito-block-despacho-shipping__distrito");
                distrito.dispatchEvent(new Event("change", { bubbles: true }));
                $(`input[name="enova-despacho-tipo"][value="${getCustomerData("shippingMethodType")}"]`).prop('checked', true).trigger('change');
            }
        })
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {
        setResetSelectorOptions('provinces', true);
        setResetSelectorOptions('distrits', true);

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => setSelectorOptions("provinces", result, true))
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true);
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => setSelectorOptions("distrits", result, true))
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        if(!jQuery("#formulario--billing-address_checkbox").prop("checked")) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
        }
    });
}

/* -------------------------------------------------------------------------
 * 6. FLUJO DE CHECKOUT
 * ------------------------------------------------------------------------- */
function handleCheckoutSubmit(ev) {
    ev.preventDefault();

    if( !jQuery("#terms_conditions").prop("checked") ) {
        document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    $("#enova-message-carrito").removeClass("active");
    document.querySelector("#enova-message-carrito").innerHTML = "";

    let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

    function getShippingMatch() {
        let addressSelected = document.querySelector("#enova-despacho-direccion").value;
        let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : "";
        return formateAddress;
    }

    var obj_params = {
        attributes: {
            'pais': 'Peru',
            'modalidad despacho': document.querySelector("input[name=enova-despacho]:checked") ? document.querySelector("input[name=enova-despacho]:checked").value : "",
            'departamento': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
            'provincia': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
            'distrito': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
            'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
            'direccion': getShippingMatch(),
            'referencia': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
            'comprobante de pago': type_document,
            'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
            'nombre': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
            'apellido': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
            'telefono': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
            'tipo documento': document.querySelector("#enova-billing-documento-type") ? document.querySelector("#enova-billing-documento-type").value : "",
            'documento identidad': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
        }
    };

    if(document.querySelector("input[name=enova-despacho-tipo]:checked") && document.querySelector("input[name=enova-despacho-tipo]:checked").value === 'programmed') {
        obj_params['attributes']['fecha de envio'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
        obj_params['attributes']['horario de recojo'] = document.querySelector("#enova-despacho-delivery-select-horario").value;
    }

    if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
        obj_params['attributes']['ruc'] = document.querySelector("#enova-billing-doc-ruc").value;
        obj_params['attributes']['razon social'] = document.querySelector("#enova-billing-doc-razonsocial").value;
    }

    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
        obj_params.attributes['tipo de envio'] = document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '';
    }
    
    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
        obj_params.attributes['departamento'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.departamento : '';
        obj_params.attributes['provincia'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.provincia : '';
        obj_params.attributes['distrito'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.distrito : '';
        obj_params.attributes['ubigeo'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.ubigeo : '';
        obj_params.attributes['direccion'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? `Recojo Tienda: ${jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-direccion").text()}` : "";
        obj_params.attributes['referencia'] = '-';
        obj_params.attributes['tienda recojo'] = jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-titulo").text() : '';

        if( obj_params && obj_params.attributes && obj_params.attributes['fecha de recojo'] && obj_params.attributes['horario de recojo'] ) {
            obj_params.attributes['referencia'] = `Fecha: ${obj_params.attributes['fecha de recojo']}, Horario: ${obj_params.attributes['horario de recojo']}`;
        }
    }

    let formValid = true;
    const fieldsCommon = ['nombre', 'apellido', 'email', 'telefono', 'tipo documento', 'documento identidad', 'pais', 'modalidad despacho', 'comprobante de pago'];
    const fieldsDelivery = [...fieldsCommon, 'departamento', 'provincia', 'distrito', 'ubigeo', 'direccion', 'referencia', 'tipo de envio'];
    const fieldsPickup   = [...fieldsCommon];

    const dispatchMode = obj_params.attributes['modalidad despacho'] || 'delivery'; 
    const fieldsToValidate = (dispatchMode === 'recojo-tienda') ? fieldsPickup : fieldsDelivery;

    const $inputPhone     = $("#enova-billing-telefono");
    const $selectDocType  = $("#enova-billing-documento-type"); 
    const $inputDocNum    = $("#enova-billing-documento-number");
    const $msgContainer   = $("#enova-message-carrito");
    const $radioFactura   = $('input[name="enova-billing-doc"]:checked');
    const $inputRucFactura= $('#enova-billing-doc-ruc');

    $msgContainer.removeClass("active").text("");
    $inputDocNum.removeClass("input-has-error");
    $(".text-has-error.text-typedoc").remove();

    fieldsToValidate.forEach(key => {
        let value = obj_params.attributes[key];
        if (!value || value.trim() === '') {
            formValid = false;
        }
    });

    if ($inputPhone.val().length < 9) {
        formValid = false;
    }

    const docType = $selectDocType.val(); 
    const docNum  = $inputDocNum.val();
    const docLen  = docNum.length;
    let docMessage = "";
    let isDocValid = true;

    if (docType === "dni") { 
        if (docLen !== 8 || isNaN(docNum)) {
            docMessage = "El DNI debe tener 8 dígitos numéricos.";
            isDocValid = false;
        }
    } else if (docType === "ce") { 
        const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(docNum);
        if (docLen < 8 || docLen > 12 || !isAlphanumeric) {
            docMessage = "El Carnet de Extranjería debe tener entre 8 y 12 caracteres alfanuméricos.";
            isDocValid = false;
        }
    } else if (docType === "ruc") { 
        if (docLen !== 11 || isNaN(docNum)) {
            docMessage = "El RUC debe tener 11 dígitos numéricos.";
            isDocValid = false;
        }
    }

    if (!isDocValid) {
        formValid = false;
        $msgContainer.text(docMessage).addClass("active");
        $inputDocNum.addClass("input-has-error");
        $inputDocNum.parent().append(`<p class='text-has-error text-typedoc'>${docMessage}</p>`);
    }

    if ($radioFactura.val() === "factura") {
        if ($inputRucFactura.val().length !== 11 || isNaN($inputRucFactura.val())) {
            $inputRucFactura.addClass("input-has-error");
            formValid = false;
        }
    }

    if(formValid) {
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        checkoutButtonLoader(true);

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },    
            body: JSON.stringify(obj_params)
        })
        .then(response => response.json())
        .then(response => {
            document.querySelector("#enova-message-carrito").classList.remove("active");

            serviceCart2CheckoutStoreFrontAPI(obj_params)
                .then((result) => {
                    if(result && result.message && result.name === "Error") {
                        checkoutButtonLoader(false);
                        throw result;
                    }
                    
                    // Manejo del WebUrl de redirección obtenido desde GraphQL
                    if(result && result.checkout && result.checkout.webUrl) {
                        checkoutButtonLoader(true);
                        setLocalStorageCustomerData();

                        let url_checkout_ = `${result.checkout.id}`;
                        // Construcción de la URL limpia basada en el ID del Checkout
                        url_checkout_ = `https://perfumarte.pe/cart/c/${url_checkout_.split("gid://shopify/Cart/")[1] || url_checkout_.split("gid://shopify/Checkout/")[1]}&channel=buy_button&_fd=0`;
                        window.location.href = url_checkout_;
                    } else {
                        throw result;
                    }
                })
                .catch((err) => {
                    console.log("Fallo el pre-checkout, aplicando fallback a checkout normal", err);
                    checkoutButtonLoader(false);

                    fetch(window.Shopify.routes.root + 'cart.js', {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then(response => {
                        window.location.href = `https://perfumarte.pe/checkouts/cn/${response.token}`;
                    })
                    .catch((err2) => {
                        document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos productos no están disponibles, por favor vuelve a intentar";
                        document.querySelector("#enova-message-carrito").classList.add("active");
                    });
                });
        })
        .catch((error) => {
            console.error('CART Error:', error);
        });

    } else {
        if (obj_params.attributes.email === "") document.querySelector("#enova-billing-email").classList.add("input-has-error");
        else document.querySelector("#enova-billing-email").classList.remove("input-has-error");
        
        if (obj_params.attributes.nombre === "") document.querySelector("#enova-billing-name").classList.add("input-has-error");
        else document.querySelector("#enova-billing-name").classList.remove("input-has-error");
        
        if (obj_params.attributes.apellido === "") document.querySelector("#enova-billing-lastName").classList.add("input-has-error");
        else document.querySelector("#enova-billing-lastName").classList.remove("input-has-error");
        
        if (obj_params.attributes.telefono === "") {
          document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
          if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
        } else {
          if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
            document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
            if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
          } else {
            document.querySelector("#enova-billing-telefono").classList.remove("input-has-error");
            $("p.text-has-error.text-phone").remove();
          }
        }
        
        if (obj_params.attributes["tipo documento"] === "") {
          document.querySelector("#enova-billing-documento-type").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-type").classList.remove("input-has-error");
        }

        if (obj_params.attributes["documento identidad"] === "") {
          document.querySelector("#enova-billing-documento-number").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
          if(typeof validateDocumentTypeForm === "function") validateDocumentTypeForm();
        }
        
        if (obj_params.attributes["tipo de envio"] === "") {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error");
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error");
        }

        if (obj_params.attributes["modalidad despacho"] === "delivery") {
          if (obj_params.attributes.direccion === "") document.querySelector("#enova-despacho-direccion").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error");
          
          if (obj_params.attributes.referencia === "") document.querySelector("#enova-despacho-referencia").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error");
          
          if (obj_params.attributes.departamento === "Seleccione...") document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.remove("input-has-error");
          
          if (obj_params.attributes.provincia === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.remove("input-has-error");
          
          if (obj_params.attributes.distrito === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.remove("input-has-error");
        }

        if( document.querySelector("input[name=enova-despacho]:checked") ) {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`);
            }
        }

        if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`);
            }
        }

        if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0] ) {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show();
            } else {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`);
            }
        }

        if (jQuery('input[name="enova-billing-doc"]:checked').val() === "factura") {
            document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error");
            var message_validation = "El campo N de RUC debe tener 11 dígitos";
            if ($("#enova-billing-doc-ruc").parent().find('.text-has-error').length === 0) {
                $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`);
            }
        }

        if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
            if ( jQuery("#enova-billing-doc-razonsocial").val() === "" ) {
                document.querySelector("#enova-billing-doc-razonsocial").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-billing-doc-razonsocial").classList.remove("input-has-error");
            }
        }

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo";
        document.querySelector("#enova-message-carrito").classList.add("active");
    }
}

/* -------------------------------------------------------------------------
 * 7. INICIALIZADOR
 * ------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
    setFormDespacho();
    setFormBillingDoc();
    setStoresEventClick();
    calculateShippingMethodByUbigeoSelected();
    calculateShippingMethodToShowOption();
    setRenderCartFormKeypressValidation();
    cartStep1();
    
    setLogistictProgrammedDateRules();
    setInitCustomerData();
});

$('#enova-carrito-block-despacho-shipping__distrito').change(function() {
    setLogistictProgrammedDateRules();
});

var setCheckerCartDiscountLabel = setInterval(() => {
    if (window.location.href.includes("cart") && !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart();
        clearInterval(setCheckerCartDiscountLabel);

        getResponseCartItems(true)
            .then((carritoItemsListE) => {
                console.log("CARRITO READY", carritoItemsListE);
                if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                    jQuery(".enova-carrito-block").addClass("active");
                    jQuery("#enova_cart-data-submit").show();
                    jQuery(".enova-carrito-block-seleccion-despacho").hide();
                    jQuery("#despacho-title").hide();
                    jQuery(".enova-carrito-block-despacho-shipping__title").text("Ingrese su dirección de facturación");
                    jQuery(".enova-carrito-block-seleccion-despacho__container #enova-despacho-delivery-option").parent().click();
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active");
                } else {
                    jQuery(".enova-carrito-block").addClass("active");
                    jQuery("#enova_cart-data-submit").show();
                }
            });

        initSetFormDataUbigeosAvailable();
    }
}, 1000);